import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getBackDestination } from '@/lib/navigationBack';

interface BackButtonProps {
  /** Override the computed parent route */
  to?: string;
  label?: string;
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({
  to,
  label = 'Back',
  className = 'border-slate-600 hover:bg-slate-700 text-slate-300 mb-6',
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    navigate(to ?? getBackDestination(location.pathname));
  };

  return (
    <Button
      type="button"
      variant="outline"
      className={className}
      onClick={handleBack}
    >
      <ArrowLeft className="w-4 h-4 mr-2" />
      {label}
    </Button>
  );
};

export default BackButton;